import React from 'react'
import { Layout } from './Layout'
import { useProps, Params } from './useProps'

export const ArcadeMachineDetailPage = (params: Params) => <Layout {...useProps(params)} />
